(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function taraUxOverrides() {
  const locale = document.documentElement.lang || '';
  const isSpanish = locale.startsWith('es');

  const copy = {
    homeTitle: isSpanish
      ? 'Cuidado capilar de precisión que empieza en el cuero cabelludo – Tara Spain'
      : 'Precision hair care that starts at the scalp – Tara Spain',
    journal: {
      eyebrow: isSpanish ? 'Diario Tara' : 'Tara Journal',
      title: isSpanish ? 'El Dossier Tara' : 'The Tara Dossier',
      lede: isSpanish
        ? 'Ciencia capilar, rituales y criterio formulador para entender mejor el cuero cabelludo, la fibra y la forma correcta de cuidar ambos.'
        : 'Hair science, rituals, and formulation thinking to better understand the scalp, the fiber, and how to care for both with precision.'
    }
  };

  function normalizedPathname() {
    const pathname = window.location.pathname.replace(/\/+$/, '');
    return pathname || '/';
  }

  function ensureHomeTitle() {
    if (!['/', '/es-es', '/en-es'].includes(normalizedPathname())) return;
    if (document.title.trim() === 'Tara Spain') {
      document.title = copy.homeTitle;
    }
  }

  function buildJournalIntro() {
    const header = document.createElement('header');
    header.className = 'blog-posts__intro';

    const eyebrow = document.createElement('p');
    eyebrow.className = 'blog-posts__eyebrow';
    eyebrow.textContent = copy.journal.eyebrow;

    const title = document.createElement('h1');
    title.className = 'blog-posts__title';
    title.textContent = copy.journal.title;

    const lede = document.createElement('p');
    lede.className = 'blog-posts__lede';
    lede.textContent = copy.journal.lede;

    header.append(eyebrow, title, lede);
    return header;
  }

  function ensureJournalIntro() {
    if (!/\/blogs\/journal\/?$/.test(window.location.pathname)) return;

    const container = document.querySelector('blog-posts-list .tara-content-container');
    if (!container) return;

    const firstH1 = document.querySelector('main h1');
    let intro = container.querySelector('.blog-posts__intro');

    if (intro) {
      const eyebrow = intro.querySelector('.blog-posts__eyebrow');
      const title = intro.querySelector('.blog-posts__title, h1');
      const lede = intro.querySelector('.blog-posts__lede');

      if (eyebrow) eyebrow.textContent = copy.journal.eyebrow;
      if (title) title.textContent = copy.journal.title;
      if (lede) lede.textContent = copy.journal.lede;
      return;
    }

    if (firstH1 && /^(blog|journal)$/i.test(firstH1.textContent.trim())) {
      const legacyWrapper = firstH1.closest('.shopify-block, .text-block, header');
      if (legacyWrapper) legacyWrapper.style.display = 'none';
    }

    intro = buildJournalIntro();
    const anchor = container.querySelector('.blog-tags-filter, .blog-posts-container');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(intro, anchor);
    }
  }

  function run() {
    ensureHomeTitle();
    ensureJournalIntro();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.addEventListener('pageshow', run);
})();
